<template>
  <div>
    <div>
      <div v-if="listes_service.length > 0" class="cardM">
        <router-link
          :to="{
            name: 'detaille_service',
            params: { id: this.$route.params.id },
          }"
        >
          <CButton
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: -8px;
            "
            color="warning"
            class="mr-1 cl"
          >
            service
          </CButton>
        </router-link>
        <router-link
          :to="{
            name: 'detaille_vidange',
            params: { id: this.$route.params.id },
          }"
        >
          <CButton
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: 14px;
            "
            color="info"
            class="mr-1 cl"
          >
            Vidange
          </CButton>
        </router-link>
        <router-link
          :to="{
            name: 'detaille_facture_service',
            params: { id: this.$route.params.id },
          }"
        >
          <CButton
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: 11px;
            "
            color="success"
            class="mr-1 cl"
          >
            F.Service
          </CButton>
        </router-link>

        <!--  -->
        <CCard
          class="cardLDepDashbord"
          style="
            border: solid 1px #1beb11;
          "
        >
          <CCardBody>
            <CRow>
              <div class="col-5">
                <label>Matricule</label>
                <input
                  class="form-control personaliseMat"
                  disabled
                  v-model="listes_service[0].matr"
                  type="text"
                />
              </div>

              <div class="col-5">
                <label>Chauffeur</label>
                <input
                  class="form-control personaliseMat"
                  disabled
                  v-model="listes_service[0].nom_chouffeur"
                />
              </div>
              <!--  <div class="col-2">
                <img
                  @click="delete_service(listes_service[0].id)"
                  style="margin-left: 4px"
                  src="sup.png"
                />
              </div> -->
            </CRow>
          </CCardBody>
        </CCard>

        <div>
          <!-- <div class="row">
            <div class="col">
              <div class="form-group">
                <input
                  class="form-control personalise"
                  placeholder="Recherche ..."
                  type="text"
                  v-model="search"
                />
              </div>
            </div>
          </div> -->
          <div
            class="table-responsive"
            style="
              border: 1px solid #3ec436;
            "
          >
            <table class="table table-white">
              <thead>
                <tr>
                  <th scope="col">#</th>

                  <th scope="col">Num</th>

                  <th scope="col">Date</th>

                  <th scope="col">Payement</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(kilo, index) in listes_fact" :key="index">
                  <td>
                    <input
                      type="checkbox"
                      v-model="idsImprimer"
                      :value="`${kilo.id}`"
                      name="ids"
                    />
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'vidange_deatille_facture',
                        params: { id: kilo.id },
                      }"
                    >
                      {{ kilo.id }}
                    </router-link>
                  </td>

                  <td>{{ kilo.date }}</td>

                  <td>
                    <span
                      class="paye"
                      style="margin-left: -1.4% !important"
                      v-if="kilo.paye == 'Payé'"
                    >
                      Payé
                    </span>
                    <span
                      class="en_attente"
                      style="margin-left: -1.4% !important"
                      v-if="kilo.paye == 'En attente'"
                    >
                      En attente
                    </span>
                    <span
                      class="non_paye"
                      style="margin-left: -1.4% !important"
                      v-if="kilo.paye == 'Non payé'"
                    >
                      N.payé
                    </span>
                  </td>

                  <td>
                    <!-- v-if="listes_service[0].man == 1" -->
                    <a
                      :href="
                        'https://apil.auto-turki.com/api/dynamic_pdf/pdf_vidange_man/' +
                        kilo.id
                      "
                      target="_blank"
                      style="background-color: transparent !important"
                    >
                      <img style="width: 29px" src="imp.png" />
                    </a>
                  </td>
                  <td>
                    <img
                      style="width: 35px"
                      @click="updatedPaye(kilo.id)"
                      src="/icons8-check-64.png"
                    />
                  </td>
                  <td>
                    <svg
                      @click="updatedENattente(kilo.id)"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="50"
                      height="50"
                      viewBox="0 0 172 172"
                      style="fill: #000000; width: 38px; margin-top: -9px"
                    >
                      <defs>
                        <linearGradient
                          x1="86"
                          y1="8.73438"
                          x2="86"
                          y2="159.25823"
                          gradientUnits="userSpaceOnUse"
                          id="color-1_brp1xIbzY4r5_gr1"
                        >
                          <stop offset="0" stop-color="#d9e021"></stop>
                          <stop offset="1" stop-color="#fb872b"></stop>
                        </linearGradient>
                        <linearGradient
                          x1="19214.24555"
                          y1="1626.34049"
                          x2="19214.24555"
                          y2="28692.29446"
                          gradientUnits="userSpaceOnUse"
                          id="color-2_brp1xIbzY4r5_gr2"
                        >
                          <stop offset="0" stop-color="#d9e021"></stop>
                          <stop offset="1" stop-color="#fb872b"></stop>
                        </linearGradient>
                      </defs>
                      <g
                        fill="none"
                        fill-rule="nonzero"
                        stroke="none"
                        stroke-width="1"
                        stroke-linecap="butt"
                        stroke-linejoin="miter"
                        stroke-miterlimit="10"
                        stroke-dasharray=""
                        stroke-dashoffset="0"
                        font-family="none"
                        font-weight="none"
                        font-size="none"
                        text-anchor="none"
                        style="mix-blend-mode: normal"
                      >
                        <path d="M0,172v-172h172v172z" fill="none"></path>
                        <g>
                          <g>
                            <path
                              d="M86,20.91715c-35.88686,0 -65.08285,29.19599 -65.08285,65.08285c0,35.88686 29.19599,65.08285 65.08285,65.08285c35.88686,0 65.08285,-29.19599 65.08285,-65.08285c0,-35.88686 -29.19599,-65.08285 -65.08285,-65.08285zM86,144.3641c-32.18281,0 -58.3641,-26.18129 -58.3641,-58.3641c0,-32.18281 26.18129,-58.3641 58.3641,-58.3641c32.18281,0 58.3641,26.18129 58.3641,58.3641c0,32.18281 -26.18129,58.3641 -58.3641,58.3641z"
                              fill="url(#color-1_brp1xIbzY4r5_gr1)"
                            ></path>
                            <path
                              d="M112.5572,56.7815c-0.63002,-0.63009 -1.48455,-0.98408 -2.37558,-0.98408c-0.89103,0 -1.74557,0.35399 -2.37558,0.98408l-31.50791,31.50825l-12.10584,-12.09073c-1.31176,-1.31099 -3.43773,-1.31099 -4.74948,0l-9.89202,9.8947c-1.31189,1.31191 -1.31189,3.43892 0,4.75083l24.37428,24.37428c0.63002,0.63009 1.48455,0.98408 2.37558,0.98408c0.89103,0 1.74557,-0.35399 2.37558,-0.98408l43.77299,-43.79382c1.31144,-1.31184 1.31144,-3.43832 0,-4.75016zM76.29913,108.09192l-19.62312,-19.62278l5.14354,-5.14388l12.10618,12.09073c1.31172,1.31077 3.43743,1.31077 4.74915,0l31.50657,-31.50657l5.14287,5.14287z"
                              fill="url(#color-2_brp1xIbzY4r5_gr2)"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <CCard
          class="cardLDepDashbord"
          style="
            border: solid 1px #3ec436;
            width: 108% !important;
            margin-left: -12px !important;
          "
        >
          <CCardBody>
            <CRow>
              <div class="col-6">
                <span style="margin-left: 9px !important" width="30%">
                  <input
                    type="checkbox"
                    @click="select_all_via_check_box"
                    v-model="all_select"
                  />
                  cocher ({{ idsImprimer.length }})
                </span>
              </div>
              <div class="col-2">
                <span>
                  <a
                    style="color: #333"
                    :href="
                      'https://apil.auto-turki.com/api/pdf_all_service/' +
                      this.idsImprimer
                    "
                    type="button"
                  >
                    <img style="width: 29px" src="imp.png" />
                  </a>
                </span>
              </div>
              <div class="col-2">
                <img
                  style="width: 35px"
                  @click="updatedPaye_all()"
                  src="/icons8-check-64.png"
                />
              </div>
              <div class="col-2">
                <svg
                  @click="updatedENattente_all()"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="50"
                  height="50"
                  viewBox="0 0 172 172"
                  style="fill: #000000; width: 38px; margin-top: -9px"
                >
                  <defs>
                    <linearGradient
                      x1="86"
                      y1="8.73438"
                      x2="86"
                      y2="159.25823"
                      gradientUnits="userSpaceOnUse"
                      id="color-1_brp1xIbzY4r5_gr1"
                    >
                      <stop offset="0" stop-color="#d9e021"></stop>
                      <stop offset="1" stop-color="#fb872b"></stop>
                    </linearGradient>
                    <linearGradient
                      x1="19214.24555"
                      y1="1626.34049"
                      x2="19214.24555"
                      y2="28692.29446"
                      gradientUnits="userSpaceOnUse"
                      id="color-2_brp1xIbzY4r5_gr2"
                    >
                      <stop offset="0" stop-color="#d9e021"></stop>
                      <stop offset="1" stop-color="#fb872b"></stop>
                    </linearGradient>
                  </defs>
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g>
                      <g>
                        <path
                          d="M86,20.91715c-35.88686,0 -65.08285,29.19599 -65.08285,65.08285c0,35.88686 29.19599,65.08285 65.08285,65.08285c35.88686,0 65.08285,-29.19599 65.08285,-65.08285c0,-35.88686 -29.19599,-65.08285 -65.08285,-65.08285zM86,144.3641c-32.18281,0 -58.3641,-26.18129 -58.3641,-58.3641c0,-32.18281 26.18129,-58.3641 58.3641,-58.3641c32.18281,0 58.3641,26.18129 58.3641,58.3641c0,32.18281 -26.18129,58.3641 -58.3641,58.3641z"
                          fill="url(#color-1_brp1xIbzY4r5_gr1)"
                        ></path>
                        <path
                          d="M112.5572,56.7815c-0.63002,-0.63009 -1.48455,-0.98408 -2.37558,-0.98408c-0.89103,0 -1.74557,0.35399 -2.37558,0.98408l-31.50791,31.50825l-12.10584,-12.09073c-1.31176,-1.31099 -3.43773,-1.31099 -4.74948,0l-9.89202,9.8947c-1.31189,1.31191 -1.31189,3.43892 0,4.75083l24.37428,24.37428c0.63002,0.63009 1.48455,0.98408 2.37558,0.98408c0.89103,0 1.74557,-0.35399 2.37558,-0.98408l43.77299,-43.79382c1.31144,-1.31184 1.31144,-3.43832 0,-4.75016zM76.29913,108.09192l-19.62312,-19.62278l5.14354,-5.14388l12.10618,12.09073c1.31172,1.31077 3.43743,1.31077 4.74915,0l31.50657,-31.50657l5.14287,5.14287z"
                          fill="url(#color-2_brp1xIbzY4r5_gr2)"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </CRow>
          </CCardBody>
        </CCard>
      </div>

      <div v-else>
        <div class="errPage-container">
          <el-row>
            <el-col :span="12">
              <p style="margin-left: 2px" class="text-jumbo">
                Oops! aucun resultat ...
              </p>
              <CButton
                @click="$router.go(-1)"
                style="
                  margin-bottom: 7px;
                  border-radius: 15px 18px;
                  margin-top: 1px;
                  margin-left: 4px;
                  padding: 10px;
                "
                color="danger"
                class="mr-1 cl"
              >
                Retour
              </CButton>
              <router-link to="/">
                <CButton
                  style="
                    margin-bottom: 7px;
                    border-radius: 15px 18px;
                    margin-top: 1px;
                    margin-left: 4px;
                    padding: 10px;
                  "
                  color="info"
                  class="mr-1 cl"
                >
                  Accueil
                </CButton>
              </router-link>
            </el-col>
            <el-col style="margin-top: 19px; margin-left: -13px">
              <img
                src="../../assets/401_images/401.gif"
                width="355"
                height="450"
                alt="Girl has dropped her ice cream."
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      search: "",
      selected: [],
      idsImprimer: [],
      select: "",
      all_select: false,
      /*  .........*/
      listes_service: {},
      listes_fact: {},
      listes_kilo: {},
      service_id: this.$route.params.id,
    };
  },

  created() {
    this.fetchListesTypes(this.$route.params.id);
  },

  computed: {
    filteredFactureServices: function () {
      if (Array.isArray(this.listes_fact)) {
        return this.listes_fact.filter((pack) => {
          return pack.date.match(this.search) || pack.paye.match(this.search);
        });
      }
    },

    all_service() {
      let arr1 = this.listes_service.Kilometrage;

      let arr2 = this.listes_service.Kilometrage;

      let arr3 = arr1.map((item, i) => Object.assign({}, item, arr2[i]));

      console.log(arr3);
      return arr3;
    },

    calculPrix() {
      const listes_service = this.listes_service[0].programmes;

      var result = [];
      var somme = null;

      var prix = 0;

      for (var i = 0; i < listes_service.length; i++) {
        prix += listes_service[i].prix;
      }

      /*    somme += prix;
        result.push(somme); */

      return prix;
    },
  },

  methods: {
    searchUnit: _.debounce(function () {
      axios
        .get(`${apiDomain}/api/search_num_fac/` + this.search)
        /*  get('/search_unit?q='+this.search) */
        .then((response) => {
          if (this.search != "") {
            this.listes_service.data = response.data.Fact;
          }
        });
    }),
    all_imprimer() {
      axios
        .post(
          `${apiDomain}/api/del2/` + this.idsImprimer
        ) /* + this.idsImprimer */
        .then((response) => {
          this.fetchListesTypes();
          this.idsImprimer = [];
          this.all_select == true
            ? (this.all_select = false)
            : (this.all_select = true);
        });
    },
    select_all_via_check_box() {
      if (this.all_select == false) {
        this.all_select = true;
        this.listes_fact.forEach((user) => {
          this.idsImprimer.push(user.id);
        });
      } else {
        this.all_select = false;
        this.idsImprimer = [];
      }
    },

    updatedPaye_all(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_all_vid/${this.idsImprimer}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    updatedPaye(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_vid/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente_all(id) {
      fetch(
        `${apiDomain}/api/UpdatedPayement_EN_attente_all_vid/${this.idsImprimer}`,
        {
          method: "post",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_EN_attente_vid/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },
    /* .............................. */
    delete_service(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");
          window.location.reload();
        })

        .catch((err) => console.log(err));
      }
    },
    deleteKilometrageService(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/deleteKilomertarge_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");
          this.fetchListesTypes(this.$route.params.id);
        })

        .catch((err) => console.log(err));
      }
    },

    deleteTraitService(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/deleteTraitService/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");
          this.fetchListesTypes(this.$route.params.id);
        })

        .catch((err) => console.log(err));
      }
    },
    delete_service(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");

          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
      }
    },
    fetchListesTypes(id) {
      fetch(
        `${apiDomain}/api/Listes_vidange_ajouter_id/${this.$route.params.id}`
      )
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
          this.listes_fact = res.all_service[0].facture;
          this.listes_kilo = res.all_service[0].Kilometrage;
        })
        .catch((err) => console.log(err));
    },

    create(e) {
      let formData = new FormData();
      formData.append("service_id", this.$route.params.id);
      formData.append("date", this.listes_service[0].date);

      axios
        .post(`${apiDomain}/api/ajouter_facture`, formData)

        .then((res) => {
          this.$noty.success("Facture Ajouter avec Succès ! ");

          // this.$router.push("/listes_acts");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },
  },
};
</script>

<style>
.non_paye {
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0px 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /* margin-top: -15.6%; */
  margin-top: -0.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
}

.paye {
  background: #28e40c;

  opacity: 0.8;
  display: inline-block;
  padding: 0px 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /* margin-top: -15.6%; */
  margin-top: -0.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
}

.en_attente {
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0px 6px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /* margin-top: -15.6%; */
  margin-top: -0.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
}
/* ............................... */
.non_paye_f {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -8.4% !important;
  margin-top: 4.4% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.paye_f {
  position: absolute;
  background: #28e40c;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -8.4% !important;
  margin-top: 4.4% !important;
  height: 30px;
  line-height: 30px !important;
  border-radius: 15px;
}

.en_attente_f {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -8.4% !important;
  margin-top: 4.4% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}
.kit {
  position: absolute;
  background: #e80db9;
  opacity: 0.8;
  display: inline-block;
  /* padding: 0 10
px
; */
  padding: -6px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4% !important;
  margin-top: 0.4% !important;
  height: 20px !important;
  line-height: 22px !important;
  border-radius: 4px !important;
  width: auto !important;
  text-align: center !important;
}

.now_kit {
  position: absolute;
  background: white;
  opacity: 0.8;
  display: inline-block;
  padding: -6px;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  z-index: 1;
  margin-left: -7.4%;
  margin-top: -7.6% !important;
  height: 20px;
  line-height: 22px;
  border-radius: 4px;
  width: auto;
  text-align: center;
}
.vidange {
  position: absolute;
  background: #083ce4;

  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: 1.4% !important;
  height: 27px;
  line-height: 30px;
  border-radius: 6px;
}

.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */
</style>

